import React from "react";

import Badge from "../Badge/Badge";
import Hyperlink from "../Hyperlink/Hyperlink";
import FormattedDate from "../Date/Date";
import ResourceStatus, { StatusValues } from "../ResourceStatus/ResourceStatus";
import { ReactComponent as IconExternal } from "../../assets/icons/ripple-external-icon--delwp.svg";

import styles from "./SearchResultsTable.module.css";
import CombineMetadata from "../Date/CombineMetadata";

export type CellDisplayValues =
    | "badge"
    | "status"
    | "text"
    | "inlineText"
    | "subtext"
    | "textLink"
    | "date"
    | "combineMetadata"
    | "title";

export type CellContentProps = {
    cellDisplay: CellDisplayValues;
    data: string;
    url: string;
    className?: string;
    determinationdateOfDecision?: string;
    fileSize?: string;
    fileType?: string;
    header?: string;
    label: string;
    isExternalLink?: string;
    isDfp?: string;
};

export const CellContent = ({
    cellDisplay = "text",
    data,
    url,
    determinationdateOfDecision = "",
    className = "",
    isExternalLink = "false",
    isDfp = "",
}: CellContentProps) => {
    const cellData = data?.trim() ?? "";
    // Temporary replace to ensure canonical Url metadata field does not pass in old path
    if (url) url = url.replace("/_2022", "");

    switch (cellDisplay) {
        case "badge":
            return <Badge label={cellData} className={className} />;
        case "status":
            return <ResourceStatus status={cellData as StatusValues} />;
        case "textLink":
            return url ? (
                <>
                    <Hyperlink href={url} className={className}>
                        {cellData}
                        {isExternalLink && <IconExternal aria-hidden="true" />}
                    </Hyperlink>
                    {/* is Dfp for ministerial permits collection only */}
                    {isDfp == "1" ? (
                        <p className={styles.dfp}>
                            <strong>DFP</strong>
                        </p>
                    ) : (
                        ""
                    )}
                </>
            ) : (
                <>{cellData}</>
            );
        case "date":
            return <FormattedDate label={cellData} />;
        case "combineMetadata":
            return (
                <CombineMetadata
                    label={cellData}
                    determinationDate={determinationdateOfDecision}
                />
            );
        default:
            return <>{cellData.trim().replace("\\n", "\n")}</>;
    }
};

export type BodyCellProps = {
    cellDisplay: CellDisplayValues;
    data: string;
    url: string;
    determinationdateOfDecision?: string;
    isExternalLink?: string;
};

const BodyCell = (props: BodyCellProps) => {
    return (
        <td className={styles.cell}>
            <CellContent label={""} {...props} />
        </td>
    );
};

export default BodyCell;
